module.exports = __webpack_public_path__ + "static/tat-40-ef4e2da48459ddb813ab2503b4c02fa9.jpg";